import { render, staticRenderFns } from "./SessionPresentationsList.vue?vue&type=template&id=2190560e"
import script from "./SessionPresentationsList.vue?vue&type=script&lang=ts"
export * from "./SessionPresentationsList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports